export { default as Method } from './Method';
